import { useState, useEffect } from "react";
import { configurePipelineClient } from "../services/pipeline";

const STORAGE_KEY = "devportal-aws-credentials";

interface StoredCreds {
  accessKeyId: string;
  secretAccessKey: string;
  configured: boolean;
}

export default function AwsConfig({ onConfigured }: { onConfigured: () => void }) {
  const [accessKeyId, setAccessKeyId] = useState("");
  const [secretAccessKey, setSecretAccessKey] = useState("");
  const [configured, setConfigured] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const creds: StoredCreds = JSON.parse(stored);
      if (creds.configured) {
        configurePipelineClient({
          accessKeyId: creds.accessKeyId,
          secretAccessKey: creds.secretAccessKey,
        });
        setConfigured(true);
        onConfigured();
      }
    }
  }, [onConfigured]);

  function handleSave(e: React.FormEvent) {
    e.preventDefault();
    configurePipelineClient({ accessKeyId, secretAccessKey });
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ accessKeyId, secretAccessKey, configured: true })
    );
    setConfigured(true);
    setShowForm(false);
    onConfigured();
  }

  function handleClear() {
    localStorage.removeItem(STORAGE_KEY);
    setConfigured(false);
    setAccessKeyId("");
    setSecretAccessKey("");
  }

  if (configured && !showForm) {
    return (
      <div className="aws-config-status">
        <span className="config-dot connected" />
        <span>AWS Connected</span>
        <button className="config-link" onClick={() => setShowForm(true)}>Change</button>
        <button className="config-link" onClick={handleClear}>Disconnect</button>
      </div>
    );
  }

  return (
    <div className="aws-config-panel">
      <div className="config-header">
        <span className="config-dot disconnected" />
        <span>{configured ? "Update AWS Credentials" : "Connect to AWS"}</span>
      </div>
      <form onSubmit={handleSave} className="config-form">
        <input
          type="text"
          placeholder="Access Key ID"
          value={accessKeyId}
          onChange={(e) => setAccessKeyId(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Secret Access Key"
          value={secretAccessKey}
          onChange={(e) => setSecretAccessKey(e.target.value)}
          required
        />
        <div className="config-actions">
          <button type="submit" className="btn btn-primary">Connect</button>
          {showForm && (
            <button type="button" className="btn" onClick={() => setShowForm(false)}>Cancel</button>
          )}
        </div>
      </form>
      <p className="config-hint">
        Use credentials with CodePipeline access in the Tooling account (225602822569).
      </p>
    </div>
  );
}
